var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "drop-down",
    {
      attrs: { "should-close": _vm.shouldCloseDropdown },
      on: {
        closeDropdown: function (val) {
          return (this$1.shouldCloseDropdown = val)
        },
        closeOtherDropDown: _vm.closeOtherDropDown,
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "status",
          class: [
            "issue-status-" + _vm.getStatusClassName(_vm.issue.issueStatusId),
            _vm.statusOptions.length ? "" : "no-pointer",
            _vm.shouldShowMobileStyle ? "mobile-status" : "",
          ],
          attrs: { slot: "title", "data-toggle": "dropdown" },
          slot: "title",
        },
        [
          !_vm.shouldShowMobileStyle
            ? _c("span", [
                _vm._v(_vm._s(_vm.getStatusName(_vm.issue.issueStatusId))),
              ])
            : _c("span", [
                _vm._v(
                  _vm._s(_vm.getStatusName(_vm.issue.issueStatusId).charAt(0))
                ),
              ]),
        ]
      ),
      _c(
        "ul",
        {
          staticClass: "dropdown-menu",
          class: { "mobile-dropdown": _vm.shouldShowMobileStyle },
        },
        _vm._l(_vm.statusOptions, function (status, index) {
          return _c("li", { key: index }, [
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.changeStatus(status)
                  },
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(status.statusName) +
                    "\n            "
                ),
              ]
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }